var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 1.25C3.50812 1.25 3 1.75812 3 2.375V2.75H2.625C1.73202 2.75 1 3.48202 1 4.375V7.875C1 8.49188 1.50812 9 2.125 9H3V9.625C3 10.2419 3.50812 10.75 4.125 10.75H7.875C8.49188 10.75 9 10.2419 9 9.625V9H9.875C10.4919 9 11 8.49188 11 7.875V4.375C11 3.48202 10.268 2.75 9.375 2.75H9V2.375C9 1.75812 8.49188 1.25 7.875 1.25H4.125ZM4.125 2H7.875C8.08662 2 8.25 2.16338 8.25 2.375V2.75H3.75V2.375C3.75 2.16338 3.91338 2 4.125 2ZM2.625 3.5H9.375C9.86252 3.5 10.25 3.88748 10.25 4.375V7.875C10.25 8.08662 10.0866 8.25 9.875 8.25H9V7.375C9 6.75812 8.49188 6.25 7.875 6.25H4.125C3.50812 6.25 3 6.75812 3 7.375V8.25H2.125C1.91338 8.25 1.75 8.08662 1.75 7.875V4.375C1.75 3.88748 2.13748 3.5 2.625 3.5ZM4.125 7H7.875C8.08662 7 8.25 7.16338 8.25 7.375V9.625C8.25 9.83663 8.08662 10 7.875 10H4.125C3.91338 10 3.75 9.83663 3.75 9.625V7.375C3.75 7.16338 3.91338 7 4.125 7Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/printIcon.79ce13861756fd17d5ec61332a16f639.svg";
export { ForwardRef as ReactComponent };